import React from 'react';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';
import { useBrandName } from '../context/SettingsContext';

const Cgv = () => {
  const brandName = useBrandName();

  return (
    <LegalPageLayout
      title="Conditions générales de vente"
      subtitle="Conditions applicables aux réservations d'ateliers, cursus et stages."
      badge="CGV"
      path="/cgv"
      lastUpdated="2025-01-15"
      metaDescription={`Conditions générales de vente ${brandName} — réservation, paiement, annulation et remboursement des ateliers et stages.`}
    >
      <LegalSection title="1. Objet">
        <p>
          Les présentes conditions générales de vente (CGV) régissent les relations contractuelles
          entre <strong>{brandName}</strong> et toute personne physique ou morale (ci-après « le Client »)
          souhaitant réserver un atelier, un cursus ou un stage via le site internet.
        </p>
        <p>
          Toute commande implique l&apos;acceptation sans réserve des présentes CGV.
        </p>
      </LegalSection>

      <LegalSection title="2. Prestations">
        <p>
          {brandName} propose des prestations de formation en robotique, programmation et STEM
          pour enfants et adolescents, sous forme d&apos;ateliers ponctuels, de cursus annuels
          ou de stages vacances.
        </p>
        <p>
          Les descriptions, durées et tarifs des prestations sont indiqués sur le site au moment
          de la réservation et peuvent être modifiés à tout moment.
        </p>
      </LegalSection>

      <LegalSection title="3. Réservation et paiement">
        <p>
          La réservation est effective après validation du paiement en ligne (Stripe) ou confirmation
          manuelle par {brandName}. Les tarifs affichés sont en euros TTC, sauf mention contraire.
        </p>
        <ul>
          <li>Le Client reçoit une confirmation par email après paiement validé.</li>
          <li>En cas de paiement refusé, la réservation est automatiquement annulée.</li>
          <li>Les codes promo sont applicables selon les conditions affichées lors de la commande.</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Annulation et remboursement">
        <p>
          Toute annulation doit être signalée par email à{' '}
          <a href="mailto:contact@digirobot.fr">contact@digirobot.fr</a>.
        </p>
        <p>
          Les conditions de remboursement dépendent du type de prestation et du délai avant
          la date prévue :
        </p>
        <ul>
          <li>Plus de 7 jours avant : remboursement intégral ou report possible.</li>
          <li>Entre 3 et 7 jours : avoir ou report selon disponibilité.</li>
          <li>Moins de 3 jours : aucun remboursement, sauf cas de force majeure.</li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Responsabilité">
        <p>
          {brandName} s&apos;engage à fournir les prestations décrites lors de la réservation,
          dans le respect des normes de sécurité applicables aux activités avec mineurs.
        </p>
        <p>
          La responsabilité de {brandName} ne saurait être engagée en cas de force majeure,
          d&apos;événement indépendant de sa volonté ou de non-respect des consignes de sécurité
          par le participant.
        </p>
      </LegalSection>

      <LegalSection title="6. Données personnelles">
        <p>
          Les données collectées lors de la réservation sont traitées conformément à notre
          politique de confidentialité et au RGPD. Le Client dispose d&apos;un droit d&apos;accès,
          de rectification et de suppression de ses données.
        </p>
      </LegalSection>

      <LegalSection title="7. Droit applicable">
        <p>
          Les présentes CGV sont soumises au droit français. En cas de litige, et après tentative
          de résolution amiable, les tribunaux compétents seront ceux du ressort du siège social
          de {brandName}.
        </p>
      </LegalSection>

      <p className="text-sm text-gray-500 italic px-2 pt-2">
        Document provisoire — à compléter avec les informations juridiques définitives
        (SIRET, capital social, numéro TVA) avant mise en production.
      </p>
    </LegalPageLayout>
  );
};

export default Cgv;
